import React from 'react';
import { hashHistory } from 'react-router';
import { connect } from 'react-redux';
import cookie from 'cookie-machine';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { resourceApi } from '../utils/fetchUtil';
import '../index.css';
import CircularProgress from 'material-ui/CircularProgress';
import HeaderSmall from '../Components/Header/HeaderSmall';
import ProviderList from '../Components/ProviderList';
import { selectShoppableCptRecord, receiveSearchResults, loadFacility, setCost } from '../actions/shopActions';
import { logProviderView } from '../actions/logActions';
import TabStrip from '../Components/TabStrip';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import Submit from 'material-ui/svg-icons/navigation/refresh';
import Paper from 'material-ui/Paper';

class SearchPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedIndex: 0,
      costEstimate: "",
      fetching: false,
      searchResults: {
        Results: []
      },
      view: 'list',
      provider: {},
      location: this.props.member.Address1 ? `${this.props.member.Address1}, ${this.props.member.City}, ${this.props.member.State} ${this.props.member.Zip}` : this.props.member.Latitude && this.props.member.Longitude ? null : null,
      distance: 200,
      distanceForSummary: 200,
      lat: cookie.get("latitude"),
      lng: cookie.get("longitude"),
      city: this.props.member.City,
      state: this.props.member.State,
      zipCode: ((this.props.member.Zip && this.props.member.Zip.substring(0, 5)) || ''),
      locationType: this.hasAddress() ? 0 : 1,
    }


    this.loadProvider = this.loadProvider.bind(this);
    this.loadResults = this.loadResults.bind(this);
    this.generateCostEstimate = this.generateCostEstimate.bind(this);
    this.selectResult = this.selectResult.bind(this);


  }

  componentDidMount() {

    this.setState({
      selectedIndex: 0
    });

    this.loadResults();

  }

  hasAddress = () => {

    if (this.props.member.Address1) {
      if (this.props.member.Address1 != "") {
        return true;
      }
    }

    return false;
  }

  goBack() {
    hashHistory.goBack()
  }

  getLocationTypeLabel = () => {
    if (this.state.locationType == 0) {
      return "Home"
    }

    if (this.state.locationType == 1) {
      return "Zip Code"
    }

    if (this.state.locationType == 2) {
      return "City/State"
    }
  }

  generateCostEstimate(data) {

    var low = 0;
    var high = 0;

    if (data.length > 0) {
      low = data[0].Price;
      high = data[data.length - 1].Price;
    }

    this.setState({ costEstimate: "$" + Math.round(low) + " - $" + Math.round(high) });
  }

  loadResults() {

    var self = this;

    self.setState({ fetching: true });

    var lat = cookie.get("latitude");
    var lng = cookie.get("longitude");

    let query = {
      ShoppableCPTCodeID: this.props.params.value,
      Latitude: lat,
      Longitude: lng,
      Distance: this.state.distance,
      LocationType: this.state.locationType,
      City: this.state.city,
      State: this.state.state,
      ZipCode: this.state.zipCode,

    };

    let config = {
      method: 'post',
      url: `shop/prices`,
      data: query
    };

    resourceApi(config)
      .then(function (response) {
        console.log(response);
        self.setState({ searchResults: response.data, fetching: false, distanceForSummary: self.state.location == null ? 0 : self.state.distance });
      })
      .catch(function (error) {
        console.log(error);
      });
  }


  selectResult = (providerId, cost, isDx) => {
    var self = this;
    hashHistory.push(`provider/${providerId}/view/${self.props.params.value}/${cost}/${this.state.searchResults.RequiresDocAndFacility}/${isDx}`);
  };



  loadProvider(providerId, cost) {

    var self = this;

    this.setState({ fetching: true });

    this.props.setCost(cost);

    var lat = cookie.get("latitude");
    var lng = cookie.get("longitude");

    let query = {
      ShoppableCPTCodeID: this.props.params.value,
      Latitude: lat,
      Longitude: lng
    };

    let config = {
      method: 'post',
      url: `shop/prices`,
      data: query
    };

    resourceApi(config)
      .then(function (response) {
        console.log(response);
        self.setState({ searchResults: response.data, fetching: false });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  dropDownDistance = () => {
    const style = {
      flexBasis: "40%",
      textAlign: "left",
    }

    return (
      <div style={style}>
        <SelectField floatingLabelText={"Distance"} fullWidth={false} style={{ width: 170 }} value={this.state.distance} onChange={this.handleDistanceChange}>
          <MenuItem value={50} primaryText="50 Miles" />
          <MenuItem value={100} primaryText="100 Miles" />
          <MenuItem value={150} primaryText="150 Miles" />
          <MenuItem value={200} primaryText="200 Miles" />
          <MenuItem value={250} primaryText="250 Miles" />
          <MenuItem value={0} primaryText="Any Distance" />
        </SelectField>
      </div>
    )
  }

  dropDownLocationType = () => {
    const style = {
      flexBasis: "60%",
      textAlign: "left",
    }

    return (
      <div style={style}>
        <SelectField floatingLabelText={"Location Type"} fullWidth={false} style={{ width: this.state.locationType == 0 ? "70%" : "100%" }} value={this.state.locationType} onChange={this.handleLocationTypeChange}>
          {this.props.member.Address1 != null && (
            <MenuItem value={0} primaryText="Home" />
          )}
          <MenuItem value={1} primaryText="Zip Code" />
          <MenuItem value={2} primaryText="City, State" />
          {this.state.lat && this.state.lng && (
            <MenuItem value={null} primaryText="Current Location" />
          )}
        </SelectField>
        {this.state.locationType == 0 && (
          this.submitButton()
        )}
      </div>
    )
  }

  zipCode = () => {
    return (
      <div style={{ display: "flex", width: "90%", margin: "0 auto" }}>
        <div style={{ flexBasis: "100%" }}>
          <TextField inputStyle={{ paddingBottom: 9 }} style={{ width: "85px" }} value={this.state.zipCode} onChange={this.handleZipChange} floatingLabelText={"Zip Code"} />
        </div>
      
      </div>
    )
  }

  cityState = () => {
    return (
      <div style={{ display: "flex", width: "90%", margin: "0 auto" }}>
        <div style={{ flexBasis: "70%" }}>
          <TextField style={{ width: "100%" }} value={this.state.city} onChange={this.handleCityChange} floatingLabelText={"City"} />
        </div>
        <div style={{ flexBasis: "30%" }}>
          <TextField style={{ width: "100%" }} value={this.state.state} onChange={this.handleStateChange} floatingLabelText={"State"} />
        </div>
        {this.state.locationType == 2 && (
          this.submitButton()
        )}
      </div>
    )
  }

  handleZipChange = (e, v) => {
    if (v.length < 6 && /^\d*$/.test(v)) {
      this.setState({ zipCode: v })
    }
  }

  handleCityChange = (e, v) => {
    if (v.length < 25) {
      this.setState({ city: v })
    }
  }

  handleStateChange = (e, v) => {
    if (v.length < 3) {
      this.setState({ state: v })
    }
  }

  handleLocationTypeChange = (e, i, v) => {
    this.setState({ locationType: v })
  }

  handleDistanceChange = (e, i, v) => {
    this.setState({ distance: v })
  }

  showChange = () => {
    this.setState({ changeOpen: !this.state.changeOpen })
  }

  submitButton = () => {
    let locationType = this.state.locationType;
    let disable = true;

    switch (locationType) {
      case 0:
        disable = false;
        break;
      case 1:
        if (this.state.zipCode != null && this.state.zipCode.length == 5) {
          disable = false;
        } else {
          disable = true;
        }
        break;
      case 2:
        if ((this.state.city != null && this.state.city.length > 0) && (this.state.state != null && this.state.state.length == 2)) {
          disable = false;
        } else {
          disable = true;
        }
        break;
      case 3:
        if (this.state.lat && this.state.lng) {
          disable = false;
        } else {
          disable = true;
        }

    }

    return (
      <FlatButton primary={true} disabled={disable} onClick={this.reSubmit} icon={ <Submit />} /> 
    )
  }


  getLocation = () => {
    var location = "";
    if (this.state.locationType == 0) {
      if (this.props.member.Address1 && this.props.member.City && this.props.member.State && this.props.member.Zip) {
        var zip = this.props.member.Zip.substring(0, 5);
        location = `${this.props.member.City}, ${this.props.member.State} ${zip}`
        
      }
      else if (this.state.lat != null) {
        location = 'location.'
      } else {
        location = "home."
      }
    }
    else if (this.state.locationType == 1) {
      location = `Zip Code ${this.state.zipCode}.`
    }
    else if (this.state.locationType == 2) {
      location = `${this.state.city}, ${this.state.state}.`
    } else {
      location = `your current location.`
    }

    return location;
  }

  reSubmit = () => {
    console.log(this.props.member.Zip, this.state.zipCode)
    let zipCheck = this.props.member.Zip && this.props.member.Zip.toString().includes(this.state.zipCode.toString())
    this.setState({ locationType: zipCheck ? 0 : 1 }, () => {

      let location = "";
      if (this.state.locationType == 0) {
        if (this.props.member.Address1 && this.props.member.City && this.props.member.State && this.props.member.Zip) {
          var zip = this.props.member.Zip.substring(0, 5);
          location = `${this.props.member.City}, ${this.props.member.State} ${zip}`
        }
        else if (this.state.lat != null) {
          location = 'location.'
        } else {
          location = "home."
        }
      }
      else if (this.state.locationType == 1) {
        location = `Zip Code ${this.state.zipCode}.`
      }
      else if (this.state.locationType == 2) {
        location = `${this.state.city}, ${this.state.state}.`
      } else {
        location = `your current location.`
      }
      this.setState({ changeOpen: false, location: location })
      this.loadResults();

    })
  }

  render() {

    return (
      <div>

        <HeaderSmall title="Search Results" />


        {(this.state.fetching) && (
          <div className="loader" >
            <CircularProgress />
          </div>
        )}

        {(!this.state.fetching) && (
          <div className="container">

            {(this.state.searchResults.Results.length === 0) && (
              <div>
                <h4>No results returned for this search.</h4>
                <br />
                <RaisedButton label="< Return" primary={true} fullWidth={true} onClick={this.goBack} />
              </div>
            )}

            {(this.state.searchResults.Results.length > 0) && (
              <div >
                <div className="centered" style={{ padding: "0 0 5px 0" }}>

                  <div >
                    <h5>Results for: {localStorage.getItem('term')}</h5>

                  </div>
                  {this.state.searchResults.Disclaimer && (
                    <div style={{ color: "#ef5350" }}>
                      {this.props.member.IsCareGuideActive && (
                        <span>{this.state.searchResults.Disclaimer}</span>
                      )}
                      {!this.props.member.IsCareGuideActive && (
                        <span>To confirm your procedure is free, contact customer care.</span>
                      )}
                    </div>
                  )}

                  <div>
                    {(this.hasAddress() || (this.state.zipCode)) && !this.state.changeOpen && (
                      <div>
                        <span style={{ fontSize: "10pt" }}>Within <b>{this.state.distanceForSummary == 0 ? "Any Distance" : this.state.distanceForSummary + " miles"}</b> of <b>{this.getLocation()}</b></span><a style={{ textDecoration:"none"}} onClick={this.showChange}><span style={{ color: window.muiTheme.palette.primary1Color, fontWeight: 600 }}> Change</span></a>
                        <br />
                      </div>
                    )}
                    {!this.hasAddress() && !this.state.changeOpen && (!this.state.zipCode) && (
                      <a style={{ textDecoration:"none"}}onClick={this.showChange}><span style={{color: window.muiTheme.palette.primary1Color, fontWeight: 600 }}> Click here to filter by location</span></a>
                    )}

                  </div>

                  {this.state.changeOpen && (
                    <Paper zDepth={0} style={{ marginTop: "10px", paddingTop: "5px", paddingBottom: "5px" }}>
                      <div style={{ display: "flex", width: "90%", margin: "0 auto" }}>
                        <table>
                          <tr>
                            <td style={{ width: 170 }}>{this.dropDownDistance()}</td>
                            <td style={{ width: 100 }}>
                              {this.zipCode()}
                            </td>
                            <td style={{ width: 70 }}>{this.submitButton()}</td>
                          </tr>
                        </table>

                        {/* {this.dropDownLocationType()} */}
                      </div>
                      {/* {this.state.locationType == 1 && (
                              <div>
                                {this.zipCode()}
                              </div>
                            )}                            
                            {this.state.locationType == 2 && (
                              <div>
                                {this.cityState()}
                              </div>
                            )} */}
                    </Paper>
                  )}
                </div>

                <ProviderList providers={this.state.searchResults.Results} requireDocAndFacility={this.state.searchResults.RequiresDocAndFacility} selectProvider={this.selectResult} />

              </div>
            )}

            <br />
            <br /><br /><br />
            <br />
          </div>

        )}

      </div>
    );
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleShoppableCptSelect: (rowIndex) => {
      dispatch(selectShoppableCptRecord(rowIndex))
    },
    receiveResults: (results) => {
      dispatch(receiveSearchResults(results))
    },
    loadFacility: (facilityId, distance) => {
      dispatch(loadFacility(facilityId, distance))
    },
    setCost: (cost) => {
      dispatch(setCost(cost))
    },
    logProviderView: (providerId, sctp, cost) => {
      dispatch(logProviderView(providerId, sctp, cost))
    }
  }
}

const mapStateToProps = (state) => ({
  searchResults: state.thisApp.searchResults,
  searchTerm: state.thisApp.searchResults.searchTerm,
  geolocation: state.thisApp.geolocation,
  member: state.thisApp.auth.member,
})


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage)




// WEBPACK FOOTER //
// ./src/Pages/SearchResults.js